import { render, staticRenderFns } from "./SavTemplate.vue?vue&type=template&id=627f3858&"
import script from "./SavTemplate.vue?vue&type=script&lang=js&"
export * from "./SavTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports